import dynamic from 'next/dynamic'
import React from 'react'

import { useSelector } from 'react-redux'

import Box from '@material-ui/core/Box'

import Desktop from '~/containers/Desktop'
import Mobile from '~/containers/Mobile'

import { isLogged } from '~/state/modules/user'

const SearchFiltersDesktop = dynamic(() => import('./DesktopFilters'))
const SearchFiltersMobile = dynamic(() => import('./MobileFilters'))

interface SearchFiltersProps {
  change: (field: string, value: any) => void
}

const SearchFilters: React.FC<SearchFiltersProps> = ({ change }) => {
  const logged = useSelector(isLogged)

  return (
    <Box minHeight="50px">
      <Desktop>
        <SearchFiltersDesktop logged={logged} change={change} />
      </Desktop>
      <Mobile>
        <SearchFiltersMobile logged={logged} change={change} />
      </Mobile>
    </Box>
  )
}

export default React.memo(SearchFilters)
